import { motion } from "framer-motion";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What exactly is a Mystery Scoop?",
    a: "A Mystery Scoop is our signature luxury gift experience. Each package includes golden eggs, scoops of magical pearl accessories, and mystical diamond capsules — all containing surprise designer-inspired items curated just for you. You won't know exactly what you're getting until the big reveal!",
  },
  {
    q: "What's inside the golden eggs?",
    a: "Each golden egg contains a stunning designer-inspired surprise — from luxury handbags to premium accessories. The contents vary based on your package tier and the style preferences you share with us. Every egg is a one-of-a-kind reveal!",
  },
  {
    q: "Can I choose my designer or specific items?",
    a: "While you can't pick exact items (that's the mystery!), you do share your favorite colors, preferred purse styles, designer preferences, and jewelry tastes when you order. We use these preferences to curate your scoop so it matches your personal style.",
  },
  {
    q: "How does the live reveal work?",
    a: "We host live scooping events on TikTok and Facebook! During the live, we call your name, ring the gong, and open your golden eggs and capsules on camera for everyone to see. It's exciting, fun, and you get to share the moment with our whole community. Pre-recorded reveals are also available.",
  },
  {
    q: "What package should I choose?",
    a: "It depends on how big you want your surprise to be! The Duchess ($225) is perfect for first-timers with 1 golden egg. The Queen's Crown ($525) and The Royal Highness ($625) are our most popular tiers with multiple eggs and scoops. Go all-in with The Queen ($725) for the ultimate luxury experience.",
  },
  {
    q: "How do I pay for my order?",
    a: "After filling out the order form with your preferences, you'll be directed to our secure Square payment page for your selected package. We accept all major credit and debit cards through Square's secure checkout.",
  },
  {
    q: "When will I receive my mystery scoop?",
    a: "Live scoop events are scheduled regularly — follow us on TikTok and Facebook for upcoming dates. Once your order is placed, we'll contact you with your scheduled reveal date. If you prefer a pre-recorded reveal, we'll arrange that and send you the video!",
  },
  {
    q: "Can I order a Mystery Scoop as a gift?",
    a: "Absolutely! Mystery Scoops make incredible gifts. Just fill out the order form with the recipient's style preferences, and mention in the notes that it's a gift. We'll make the reveal extra special!",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 relative"
    >
      <div className="absolute inset-0 section-glow-pink" />

      <div className="max-w-3xl mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <p className="font-great-vibes text-[#FF007F] text-2xl md:text-3xl mb-4">
            Common Questions
          </p>
          <h2 className="font-playfair text-[#D4AF37] text-4xl md:text-5xl font-bold">
            FAQ
          </h2>
          <div className="gold-line w-24 mx-auto mt-6" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={faq.q}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border border-[#D4AF37]/10 rounded-xl px-6 bg-white/[0.02] hover:border-[#D4AF37]/25 transition-colors duration-300"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="font-playfair text-white text-base md:text-lg hover:no-underline hover:text-[#D4AF37] py-5 [&>svg]:text-[#D4AF37]/60"
                >
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent
                  data-testid={`faq-content-${i}`}
                  className="font-montserrat text-white/50 text-sm leading-relaxed pb-5"
                >
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
